import { createQueryKeys } from "@lukemorales/query-key-factory";
import api from "utils/api";

import { endpoints } from "utils/endpoints";
import { IListResponse } from "common/models/GridModels";
import {
  ICirculation,
  ICirculationGridFilter,
  IDueMaterial,
  IDueMaterialGridFilter,
  IGeneralCard,
  IIssuedItemChart,
  IIssuedItemChartGridFilter,
  IMaterialTypeWiseCount,
  IMemberTypeChart,
  IMemberTypeChartGridFilter,
  IMonthlyCirculation,
  IMonthlyCirculationGridFilter,
  IProgramCirculation,
  IProgramCirculationGridFilter,
  ITitleVolume,
  ITitleVolumeGridFilter,
  IVisitor,
  IVisitorGridFilter,
  IYearlyCirculation,
  IRecentlyAddedBook,
  IRecentlyAddedBooksSummary,
  IRecentlyAddedBooksGridFilter,
} from "./types";
import { PostModel } from "common/models/BaseModel";

export const dashboard = createQueryKeys("dashboard", {
  //   list: (postModel: PostModel<IUniversityGridFilter>) => ({
  //     queryKey: [postModel],
  //     queryFn: () =>
  //       api.post<IListResponse<IUniversityGridModel>>(
  //         endpoints.university.list,
  //         postModel
  //       ),
  //   }),

  //   getById: (Id: number) => ({
  //     queryKey: [Id],
  //     queryFn: () =>
  //       api.get<IUniversity>(`${endpoints.university.getById}/${Id}`),
  //   }),

  getMaterialTypeWiseCount: () => ({
    queryKey: ["material"],
    queryFn: () =>
      api.get<IListResponse<IMaterialTypeWiseCount>>(
        endpoints.dashboard.getMaterialTypesCount,
      ),
  }),

  getVisitors: (postModel: PostModel<IVisitorGridFilter>) => ({
    queryKey: [postModel, "visitors"],
    queryFn: () =>
      api.post<IListResponse<IVisitor>>(
        endpoints.dashboard.getVisitors,
        postModel,
      ),
  }),

  getTitleVolume: (postModel: PostModel<ITitleVolumeGridFilter>) => ({
    queryKey: [postModel, "titleVolume"],
    queryFn: () =>
      api.post<IListResponse<ITitleVolume>>(
        endpoints.dashboard.getTitleVolume,
        postModel,
      ),
  }),

  getCirculation: (postModel: PostModel<ICirculationGridFilter>) => ({
    queryKey: [postModel, "circulation"],
    queryFn: () =>
      api.post<IListResponse<ICirculation>>(
        endpoints.dashboard.getCirculation,
        postModel,
      ),
  }),

  getProgramCirculation: (
    postModel: PostModel<IProgramCirculationGridFilter>,
  ) => ({
    queryKey: [postModel, "programCirculation"],
    queryFn: () =>
      api.post<IListResponse<IProgramCirculation>>(
        endpoints.dashboard.getProgramCirculation,
        postModel,
      ),
  }),

  getDueMaterial: (postModel: PostModel<IDueMaterialGridFilter>) => ({
    queryKey: [postModel, "dueMaterial"],
    queryFn: () =>
      api.post<IListResponse<IDueMaterial>>(
        endpoints.dashboard.getDueMaterial,
        postModel,
      ),
  }),

  getGeneralDashboard: () => ({
    queryKey: ["general"],
    queryFn: () =>
      api.get<IListResponse<IGeneralCard>>(
        endpoints.dashboard.getGeneralDashboard,
      ),
  }),

  getIssuedItemChart: (postModel: IIssuedItemChartGridFilter) => ({
    queryKey: [postModel, "issuedItem"],
    queryFn: () =>
      api.post<IIssuedItemChart[]>(
        endpoints.dashboard.getIssuedItemChart,
        postModel,
      ),
  }),

  getMemberTypeChart: (postModel: IMemberTypeChartGridFilter | undefined) => ({
    queryKey: [postModel, "memberTypeChart"],
    queryFn: () =>
      api.post<IMemberTypeChart[]>(
        endpoints.dashboard.getMemberTypeChart,
        postModel,
      ),
  }),

  getYearlyCirculation: (filter: { instituteID: string | number | null }) => ({
    queryKey: [filter, "yearlyCirculation"],
    queryFn: () =>
      api.post<IYearlyCirculation[]>(
        endpoints.dashboard.getYearlyCirculation,
        filter,
      ),
  }),

  getMonthlyCirculation: (postModel: IMonthlyCirculationGridFilter) => ({
    queryKey: [postModel, "monthlyCirculation"],
    queryFn: () =>
      api.post<IMonthlyCirculation[]>(
        endpoints.dashboard.getMonthlyCirculation,
        postModel,
      ),
  }),

  getRecentlyAddedBooks: (
    postModel: PostModel<IRecentlyAddedBooksGridFilter>,
  ) => ({
    queryKey: [postModel, "recentlyAddedBooks"],
    queryFn: () =>
      api.post<IListResponse<IRecentlyAddedBook>>(
        endpoints.dashboard.getRecentlyAddedBooks,
        postModel,
      ),
  }),

  getRecentlyAddedBooksSummary: () => ({
    queryKey: ["recentlyAddedBooksSummary"],
    queryFn: () =>
      api.get<IRecentlyAddedBooksSummary>(
        endpoints.dashboard.getRecentlyAddedBooksSummary,
      ),
  }),
});
